export default {
  HOME: "H",
  AWAY: "A",
  TOURNAMENT: "T",
};
